import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["chart"]
  }

  connect() {
    this.charts = this.chartTargets.map((element) => {
      const chart = echarts.init(element)
      const config = JSON.parse(element.dataset.chart)
      chart.setOption(this.optionsFor(config), false)
      return chart
    })

    this.resizeHandler = () => this.resize()
    window.addEventListener("resize", this.resizeHandler)
    setTimeout(this.resizeHandler, 100)
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)
    this.charts.forEach((chart) => chart.dispose())
  }

  resize() {
    this.charts.forEach((chart) => chart.resize())
  }

  optionsFor(config) {
    if (config.type === "pie") return this.pieOptions(config)

    const series = config.series.map((item, index) => ({
      name: item.name,
      type: config.type,
      data: item.data,
      smooth: config.type === "line",
      symbolSize: 7,
      yAxisIndex: item.axis || 0,
      itemStyle: { color: this.colors[index % this.colors.length] }
    }))
    const hasSecondAxis = config.series.some((item) => item.axis === 1)

    return {
      color: this.colors,
      tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
      legend: { top: 14 },
      toolbox: { right: 18, feature: { saveAsImage: { pixelRatio: 2 } } },
      grid: { left: 72, right: hasSecondAxis ? 72 : 32, top: 62, bottom: 90 },
      xAxis: {
        type: "category",
        data: config.labels,
        axisLabel: { interval: 0, rotate: config.labels.length > 8 ? 35 : 0, color: "#5d6673" },
        axisLine: { lineStyle: { color: "#d9dee7" } }
      },
      yAxis: hasSecondAxis ? [{ type: "value", name: config.series[0].name }, { type: "value", name: config.series.find((item) => item.axis === 1).name }] : { type: "value" },
      series: series
    }
  }

  pieOptions(config) {
    return {
      color: this.colors,
      tooltip: { trigger: "item", formatter: "{b}<br/>{a}: {c} ({d}%)" },
      legend: { type: "scroll", bottom: 10 },
      toolbox: { right: 18, feature: { saveAsImage: { pixelRatio: 2 } } },
      series: [{
        name: config.value_name,
        type: "pie",
        radius: ["42%", "70%"],
        center: ["50%", "44%"],
        data: config.labels.map((label, index) => ({ name: label, value: config.values[index] })),
        label: { formatter: "{b}\n{d}%" }
      }]
    }
  }

  get colors() {
    return ["#345995", "#e67e22", "#2a9d8f", "#7b5ea7", "#d1495b", "#4f7cac", "#efb366", "#66999b", "#9c6644", "#577590"]
  }
}
